export const PKG = 'crop'

export const MEDIA_CLASS = `${PKG}-media`

export const ZOOM_STEP = 0.1

export const MIN_ROTATE = 0
export const MAX_ROTATE = 360
export const ROTATE_STEP = 1
